import React, { createContext, useContext, useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import apiService, { setAuthToken } from "../services/apiService";
import { useNavigate } from "react-router-dom";
import { initializeToken } from "../services/apiService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    initializeToken();
  }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else if (accounts.length > 0) {
      setUser(accounts[0]);
    }
  }, [accounts]);

  const login = async (email, password, isDeveloper = false) => {
    if (isDeveloper) {
      try {
        const response = await apiService.post("/auth/developer-login", {
          email,
          password,
        });
        setAuthToken(response.data.tokens.access.token);
        localStorage.setItem(
          "refreshToken",
          response.data.tokens.refresh.token
        );
        setUser(response.data.user);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        navigate("/dashboard");
      } catch (error) {
        console.error("Developer login failed", error.response || error);
      }
    } else {
      try {
        const result = await instance.loginPopup();
        setAuthToken(result.accessToken);
        setUser(result.account);
        localStorage.setItem("user", JSON.stringify(result.account));
        navigate("/dashboard");
      } catch (error) {
        console.error("Microsoft login failed", error);
      }
    }
  };

  // Add this useEffect to check for stored user on component mount
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const logout = () => {
    setUser(null);
    setAuthToken(null);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('isCheckingAuth');
    if (accounts.length > 0) {
      instance.logout();
    } else {
      navigate("/login");
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
